<template>
  <svg
    width="27"
    height="32"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 32"
  >
    <path
      d="M26.061 14.307c.627.375.939.94.939 1.692 0 .755-.312 1.32-.939 1.694l-23 13.994A1.962 1.962 0 0 1 2 32c-.333 0-.667-.083-1-.252-.667-.374-1-.96-1-1.756V2.008C0 1.213.355.626 1.061.252A1.85 1.85 0 0 1 2 0c.376 0 .728.104 1.061.313l23 13.994z"
      fill="#FFF"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'PlayIcon',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/icons/PlayIcon.vue